import React from 'react';
import { LayoutDashboardIcon, BotIcon, UsersIcon, ShieldCheckIcon, TrendingUpIcon, MessageCircleIcon, AlertTriangleIcon, HeartHandshakeIcon } from 'lucide-react';
export function ProductSection() {
  return <section className="w-full bg-[#f8f8f8] py-16 md:py-24 border-t border-gray-200" data-id="element-311">
      <div className="max-w-7xl mx-auto px-6 md:px-12" data-id="element-312">
        <div className="text-center mb-16" data-id="element-313">
          <h2 className="text-3xl md:text-5xl font-bold text-[#111111] mb-6" data-id="element-314">
            Everything Your Family Needs in One Place
          </h2>
          <p className="text-lg text-gray-600 max-w-3xl mx-auto" data-id="element-315">
            No more juggling apps, Googling fixes, or explaining the same thing
            twice. Caveo brings it all together.
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 mb-16" data-id="element-316">
          {/* Family Dashboard */}
          <div className="bg-white rounded-2xl p-8 border-2 border-gray-200" data-id="element-317">
            <div className="flex items-center mb-6" data-id="element-318">
              <div className="w-12 h-12 bg-[#631bb7] bg-opacity-5 rounded-xl flex items-center justify-center border border-[#631bb7] border-opacity-10 mr-4" data-id="element-319">
                <LayoutDashboardIcon className="w-6 h-6 text-[#631bb7]" data-id="element-320" />
              </div>
              <h3 className="text-2xl font-bold text-[#111111]" data-id="element-321">
                The Family Dashboard
              </h3>
            </div>
            <p className="text-gray-600 mb-6 leading-relaxed" data-id="element-322">
              A unified view of your entire family's security posture. See
              everyone's progress at a glance.
            </p>
            <div className="space-y-4" data-id="element-323">
              <div className="flex items-start" data-id="element-324">
                <TrendingUpIcon className="w-5 h-5 text-[#631bb7] mr-3 mt-0.5 flex-shrink-0" data-id="element-325" />
                <div data-id="element-326">
                  <span className="font-semibold text-[#111111]" data-id="element-327">
                    Family Security Score
                  </span>
                  <p className="text-sm text-gray-600" data-id="element-328">
                    See your family's overall protection level
                  </p>
                </div>
              </div>
              <div className="flex items-start" data-id="element-329">
                <UsersIcon className="w-5 h-5 text-[#631bb7] mr-3 mt-0.5 flex-shrink-0" data-id="element-330" />
                <div data-id="element-331">
                  <span className="font-semibold text-[#111111]" data-id="element-332">
                    Individual Progress
                  </span>
                  <p className="text-sm text-gray-600" data-id="element-333">
                    Track each family member's learning journey
                  </p>
                </div>
              </div>
              <div className="flex items-start" data-id="element-334">
                <ShieldCheckIcon className="w-5 h-5 text-[#631bb7] mr-3 mt-0.5 flex-shrink-0" data-id="element-335" />
                <div data-id="element-336">
                  <span className="font-semibold text-[#111111]" data-id="element-337">
                    Coordinated Protection
                  </span>
                  <p className="text-sm text-gray-600" data-id="element-338">
                    Shared guides prevent costly mistakes
                  </p>
                </div>
              </div>
            </div>
          </div>

          {/* AI Security Coach */}
          <div className="bg-white rounded-2xl p-8 border-2 border-gray-200" data-id="element-339">
            <div className="flex items-center mb-6" data-id="element-340">
              <div className="w-12 h-12 bg-[#631bb7] bg-opacity-5 rounded-xl flex items-center justify-center border border-[#631bb7] border-opacity-10 mr-4" data-id="element-341">
                <BotIcon className="w-6 h-6 text-[#631bb7]" data-id="element-342" />
              </div>
              <h3 className="text-2xl font-bold text-[#111111]" data-id="element-343">
                Your Security Coach
              </h3>
            </div>
            <p className="text-gray-600 mb-6 leading-relaxed" data-id="element-344">
              Patient, brilliant, and kind — like Mr. Rogers meets an Apple
              Genius.
            </p>
            <div className="space-y-4" data-id="element-345">
              <div className="flex items-start" data-id="element-346">
                <MessageCircleIcon className="w-5 h-5 text-[#631bb7] mr-3 mt-0.5 flex-shrink-0" data-id="element-347" />
                <div data-id="element-348">
                  <span className="font-semibold text-[#111111]" data-id="element-349">
                    Plain English Help
                  </span>
                  <p className="text-sm text-gray-600" data-id="element-350">
                    No jargon, just practical guidance
                  </p>
                </div>
              </div>
              <div className="flex items-start" data-id="element-351">
                <AlertTriangleIcon className="w-5 h-5 text-[#631bb7] mr-3 mt-0.5 flex-shrink-0" data-id="element-352" />
                <div data-id="element-353">
                  <span className="font-semibold text-[#111111]" data-id="element-354">
                    Proactive Alerts
                  </span>
                  <p className="text-sm text-gray-600" data-id="element-355">
                    Identifies issues before they become problems
                  </p>
                </div>
              </div>
              <div className="flex items-start" data-id="element-356">
                <HeartHandshakeIcon className="w-5 h-5 text-[#631bb7] mr-3 mt-0.5 flex-shrink-0" data-id="element-357" />
                <div data-id="element-358">
                  <span className="font-semibold text-[#111111]" data-id="element-359">
                    Human Support
                  </span>
                  <p className="text-sm text-gray-600" data-id="element-360">
                    Real people when you need them
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Learning Center Preview */}
        <div className="bg-white rounded-2xl p-8 border-2 border-gray-200" data-id="element-361">
          <div className="flex flex-col md:flex-row md:items-center md:justify-between mb-8" data-id="element-362">
            <div data-id="element-363">
              <h3 className="text-2xl font-bold text-[#111111] mb-2" data-id="element-364">
                The Learning Center
              </h3>
              <p className="text-gray-600" data-id="element-365">
                39 educational modules across three skill levels
              </p>
            </div>
            <a href="/learning-center" className="mt-4 md:mt-0 text-[#631bb7] font-semibold hover:underline" data-id="element-366">
              Explore All Modules →
            </a>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6" data-id="element-367">
            <div className="bg-[#f8f8f8] rounded-xl p-6 border border-gray-200" data-id="element-368">
              <div className="text-sm font-bold text-[#631bb7] mb-2" data-id="element-369">
                LEVEL 1 • ESSENTIALS
              </div>
              <div className="text-3xl font-bold text-[#111111] mb-2" data-id="element-370">
                9 Modules
              </div>
              <p className="text-sm text-gray-600" data-id="element-371">
                Passwords, Scams & Phishing, and more
              </p>
            </div>
            <div className="bg-[#f8f8f8] rounded-xl p-6 border border-gray-200" data-id="element-372">
              <div className="text-sm font-bold text-[#631bb7] mb-2" data-id="element-373">
                LEVEL 2 • INTERMEDIATE
              </div>
              <div className="text-3xl font-bold text-[#111111] mb-2" data-id="element-374">
                11 Modules
              </div>
              <p className="text-sm text-gray-600" data-id="element-375">
                Financial Accounts, Cloud Storage, and more
              </p>
            </div>
            <div className="bg-[#f8f8f8] rounded-xl p-6 border border-gray-200" data-id="element-376">
              <div className="text-sm font-bold text-[#631bb7] mb-2" data-id="element-377">
                SPECIALIZED GUIDES
              </div>
              <div className="text-3xl font-bold text-[#111111] mb-2" data-id="element-378">
                19 Deep Dives
              </div>
              <p className="text-sm text-gray-600" data-id="element-379">
                AI Primer, Digital Legacy, and more
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>;
}